import Flow from 'types/Flow';
import FlowsByModel from 'types/FlowsByModel';
import { ShareboxModel } from 'types/KioskTypes';

import { createDictionary } from 'utils/objectUtils';

import SHAREBOX_M28_REOPEN_STEPS from './m28';
import SHAREBOX_W64_REOPEN_STEPS from './w64';
import SHAREBOX_S32_PLUS_REOPEN_STEPS from './s32_plus';
import SHAREBOX_I32_REOPEN_STEPS, { ShareboxI32ReopenSteps } from './i32';
import SHAREBOX_S32_REOPEN_STEPS, { ShareboxS32ReopenSteps } from './s32';

type ShareboxKioskFlow = Flow<ShareboxI32ReopenSteps> | Flow<ShareboxS32ReopenSteps>;

const SHAREBOX_KIOSK_REOPEN_STEPS = createDictionary<ShareboxModel, ShareboxKioskFlow>({
  [ShareboxModel.I32]: SHAREBOX_I32_REOPEN_STEPS,
  [ShareboxModel.W64]: SHAREBOX_W64_REOPEN_STEPS,
  [ShareboxModel.S32]: SHAREBOX_S32_REOPEN_STEPS,
  [ShareboxModel.M28]: SHAREBOX_M28_REOPEN_STEPS,
  [ShareboxModel.S32_PLUS]: SHAREBOX_S32_PLUS_REOPEN_STEPS,
}, SHAREBOX_I32_REOPEN_STEPS) as FlowsByModel<ShareboxModel>;

export default SHAREBOX_KIOSK_REOPEN_STEPS;
